import { useState, useEffect } from 'react'
import { GridColDef } from '@mui/x-data-grid';
import { useParams, Link, useNavigate } from 'react-router-dom'

import { adminAPI } from '../../../api';
import { decodeUnicode, downloadObjects, StyledDataGrid, dataGridCellClassName, dataGridHeaderClassName, convertToDateTime } from '../../../utils'

import { MarkdownWithLinks } from '../../../components/MarkdownWithLinks'

import { ContentInterventionAddModal } from './ContentInterventionAddModal';

interface Props {
}

const ContentInterventions : React.FC<Props> = ({}) => {
  const [loaded, setLoaded] = useState<boolean>(false)
  const [hasNoData, setHasNoData] = useState<boolean>(false)

  const [interventions, setInterventions] = useState<any[]>()

  const { evaluation_set_id } = useParams<{ evaluation_set_id: string}>();

  const [ showContentInterventionAddModal, setShowContentInterventionAddModal ] = useState<boolean>(false)

  const navigate = useNavigate()

  useEffect(() => {
    load()
  }, [evaluation_set_id])

  async function load(){
    let {data: data} = await adminAPI.getContentInterventions()
    setInterventions(data['data'])
  }

  async function deleteOne(intervention_id: number){
    await adminAPI.deleteContentIntervention(intervention_id)
    load()
  }

  async function deleteAll(){
    if( window.confirm('Are you sure?') ){
      await adminAPI.deleteAllContentInterventions()
      load()
    }
  }

  const scroll = (text) => {
    return <div className="overflow-y-auto" style={{maxHeight: '142px'}}>{text}</div>
  }

  const handleDownload = () => {
    if( interventions ){
      downloadObjects('excel', interventions, 'interventions')
    }
  }

  const columns: GridColDef[] = [
    { field: "id", headerName: '', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 80,
      renderCell: (params) => {
        return <button className="btn btn-sm btn-light-danger fs-8 px-2 py-1" onClick={()=>deleteOne(params.row.id)}>Delete</button>
      },
    },
    { field: "prompt", headerName: 'Prompt', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150, flex:1,
      renderCell: (params) => {
        return scroll(params.value)
      }
    },
    { field: 'content', headerName: 'Content', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 250, flex:2,
      renderCell: (params) => {
        return scroll(<MarkdownWithLinks>{decodeUnicode(params.value)}</MarkdownWithLinks>)
      }
    },
    { field: 'created_dt', headerName: 'Added On', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 120,
      renderCell: (params) => {
        return convertToDateTime(params.value)
      }
    },
    { field: 'has_embedding', headerName: 'Has Embedding', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150,}

  ]

  return <div className="row">
    <div className="col-12">
      <h5>Content Interventions</h5>
      <div className="card">
        <div className="card-body pt-5">
          <div className="d-flex justify-content-between mt-5 flex-end">
            <div className="d-flex flex-row flex-center">
              <button className="btn btn-sm btn-light-dark" onClick={()=>setShowContentInterventionAddModal(true)}>
                Add
              </button>
            </div>
            <div>
              <button className="btn btn-sm btn-light-danger me-1" onClick={deleteAll}>Delete All</button>
              <button className="btn download-messages-btn btn-sm btn-light" disabled={hasNoData} onClick={handleDownload}>
                  Download
              </button>
            </div>
          </div>
          <StyledDataGrid
            getRowId={(row) => row.id}
            rows={interventions}
            columns={columns}
            disableColumnMenu={false}
            getRowHeight={() => 'auto'}
            disableRowSelectionOnClick
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 50 },
              }
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
          />
        </div>
      </div>
    </div>
    <ContentInterventionAddModal 
      show={showContentInterventionAddModal}
      handleClose={() => setShowContentInterventionAddModal(false)}
      handleUpdated={load}
    />
  </div>
}

export default ContentInterventions;
